module.exports = __webpack_public_path__ + "img/icon2.eed7d42f.svg";